var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAdminLogin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 710,
    height: 640,
    viewBox: "0 0 710 640",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M410.494 178.78L405.184 169.76L376.16 186.806L381.446 195.826L364.836 225.116L354.362 225.189L354.604 258.868L365.079 258.771L382.125 287.819L376.96 296.912L406.226 313.545L411.391 304.428L445.07 304.186L450.38 313.23L479.404 296.184L474.094 287.14L490.727 257.874L501.202 257.801L500.96 224.122L490.485 224.195L473.439 195.171L478.604 186.054L449.313 169.445L444.149 178.537L410.494 178.78Z",
    fill: "white",
    stroke: "#D70365",
    strokeWidth: 1.50769,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M427.588 214.545C442.476 214.448 454.623 226.401 454.72 241.289C454.817 256.177 442.864 268.325 427.976 268.422C413.088 268.519 400.94 256.565 400.843 241.677C400.722 226.814 412.7 214.666 427.588 214.545Z",
    fill: "white",
    stroke: "#D70365",
    strokeWidth: 1.50769,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M79.181 73.3538C79.181 73.3538 13.3016 130.916 86.3096 204.118",
    stroke: "#D70365",
    strokeWidth: 1.50769,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "15.08 15.08"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4244 393.367C11.9195 409.54 -8.52077 425.082 6.12449 447.583C16.2355 463.102 36.5304 468.63 28.6258 490.671C25.4979 499.399 19.5089 506.019 21.3032 515.839C22.8792 524.398 29.5715 531.139 35.4635 537.031C40.5312 542.099 48.6782 546.875 52.4365 553.083C58.5953 563.194 52.291 570.807 49.3813 580.846C46.5929 590.423 46.1565 600.995 51.4666 609.942C58.4983 621.775 72.2222 622.963 81.2663 631.619C81.2663 631.619 122.85 658.776 139.872 608.633C143.897 596.776 149.861 585.913 146.976 572.48C144.794 562.321 137.277 554.853 128.718 549.712C119.746 544.329 109.975 543.02 107.599 531.43C106.144 524.326 108.86 515.281 109.126 508.128C109.441 499.787 109.757 490.283 105.101 482.96C99.7426 474.522 90.844 473.746 82.5999 469.479C61.8202 458.689 72.9495 440.843 69.7974 422.585C65.239 396.131 39.6825 398.653 21.7154 393.246L21.4244 393.367Z",
    fill: "#FFE1EF",
    stroke: "#D4E6FC",
    strokeWidth: 0.3768,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M37.961 435.048L117.589 637.996",
    stroke: "#D70365",
    strokeWidth: 1.50769,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M41.3555 505.267L72.804 523.865",
    stroke: "#D70365",
    strokeWidth: 1.50769,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M102.749 600.195L119.771 572.117",
    stroke: "#D70365",
    strokeWidth: 1.50769,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M62.3051 497.048L70.6461 471.564",
    stroke: "#D70365",
    strokeWidth: 1.50769,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M90.6741 389.317H251.117V294.099L90.6741 318.079V389.317Z",
    fill: "#D70365"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M88.3464 638.99L113.394 613.24H134.561V638.99H88.3464Z",
    fill: "#D70365"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M226.119 638.99L209.922 613.24H188.754V638.99H226.119Z",
    fill: "#D70365"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M238.509 388.857V620.053H173.624V435.63H165.161L153.256 620.053H88.3464L100.252 435.63L103.283 388.857H238.509Z",
    fill: "white",
    stroke: "#D70365",
    strokeWidth: 1.49314,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M269.448 274.58C269.448 221.115 228.519 197.28 175.078 196.019C173.987 195.995 172.872 195.971 171.757 195.971C91.3531 195.971 65.9906 254.406 62.1838 264.493C53.6973 286.946 29.8382 357.359 106.726 389.923C129.858 399.719 146.394 375.957 158.736 369.604C180.267 358.523 188.026 355.759 188.026 355.759L269.448 274.58Z",
    fill: "#D70365"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M233.829 301.203C233.829 301.203 242.413 340.29 290.349 331.852C338.286 323.414 324.271 249.678 324.271 249.678H287.173L285.815 283.6C285.815 283.6 266.151 232.608 241.491 215.126C226.482 204.506 233.829 301.203 233.829 301.203Z",
    fill: "#D70365"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M250.56 285.879V326.469",
    stroke: "white",
    strokeWidth: 1.50769,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M139.459 381.195L152.941 394.773L163.804 407.624L159.245 412.207L163.246 417.469L140.72 434.975L111.454 399.793L139.459 381.195Z",
    fill: "white",
    stroke: "#D70365",
    strokeWidth: 1.50769,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M158.566 420.864L148.892 409.831",
    stroke: "#D70365",
    strokeWidth: 1.50769,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M152.213 425.204L142.539 414.171",
    stroke: "#D70365",
    strokeWidth: 1.50769,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M146.249 429.98L136.574 418.948",
    stroke: "#D70365",
    strokeWidth: 1.50769,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M159.366 412.425L152.213 404.181",
    stroke: "#D70365",
    strokeWidth: 1.50769,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M103.331 287.917C82.9878 331.343 145.351 379.158 145.351 379.158L108.035 406.97C108.035 406.97 57.8921 364.537 55.3219 335.829",
    fill: "#D70365"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M167.247 172.184C167.247 172.184 143.484 178.343 142.078 149.441C140.648 120.562 187.032 110.136 197.943 122.211C208.855 134.286 167.247 172.184 167.247 172.184Z",
    fill: "#D70365"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M169.477 211.659C177.576 211.659 184.123 205.088 184.123 197.014V149.392H154.808V197.014C154.808 205.088 161.379 211.659 169.477 211.659Z",
    fill: "white",
    stroke: "#D70365",
    strokeWidth: 1.50769,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M144.527 151.768C144.163 156.254 147.509 160.182 151.995 160.546C152.698 160.594 153.377 160.57 154.032 160.449C154.347 163.431 155.293 166.268 156.723 168.765C160.142 174.827 166.422 179.119 173.89 179.725C185.844 180.695 196.319 171.772 197.264 159.818C198.21 147.864 189.311 137.39 177.358 136.444C169.259 135.789 161.839 139.669 157.62 145.973C156.432 145.027 154.953 144.446 153.329 144.3C148.819 143.936 144.891 147.283 144.527 151.768Z",
    fill: "white",
    stroke: "#D70365",
    strokeWidth: 1.50769,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M156.602 155.89C156.602 155.89 156.675 151.768 152.601 152.011",
    stroke: "#D70365",
    strokeWidth: 1.50769,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M618.704 247.884H211.279V638.99H618.704V247.884Z",
    fill: "#FFE1EF"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M293.016 233.7L293.283 256.492L321.773 256.347L322.38 233.918L293.016 233.7Z",
    fill: "white",
    stroke: "#D70365",
    strokeWidth: 1.50769,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M299.03 256.079L299.418 241.41",
    stroke: "#D70365",
    strokeWidth: 1.50769,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M306.692 255.376L307.08 240.683",
    stroke: "#D70365",
    strokeWidth: 1.50769,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M314.329 255.207L314.717 240.537",
    stroke: "#D70365",
    strokeWidth: 1.50769,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M103.331 287.917C82.9878 331.343 145.351 379.158 145.351 379.158",
    stroke: "white",
    strokeWidth: 1.50769,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M564.123 322.177H266.563V367.931H564.123V322.177Z",
    fill: "white"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M564.123 387.135H266.563V432.89H564.123V387.135Z",
    fill: "white"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M564.123 454.105H266.563V499.86H564.123V454.105Z",
    fill: "white"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M504.912 532.375H325.774V578.13H504.912V532.375Z",
    fill: "#D70365"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M557.019 219.394C588.623 219.394 614.242 193.774 614.242 162.171C614.242 130.567 588.623 104.948 557.019 104.948C525.416 104.948 499.796 130.567 499.796 162.171C499.796 193.774 525.416 219.394 557.019 219.394Z",
    fill: "white",
    stroke: "#D70365",
    strokeWidth: 1.50769,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "15.08 15.08"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M34.8816 638.869H709",
    stroke: "#D70365",
    strokeWidth: 1.50769,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M649.619 638.869H549.818L536.239 527.72H663.173L649.619 638.869Z",
    fill: "#D70365"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M671.635 527.72H527.801V553.058H671.635V527.72Z",
    fill: "white",
    stroke: "#D70365",
    strokeWidth: 1.50769,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M599.718 527.72V414.438",
    stroke: "#D70365",
    strokeWidth: 1.50769,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M599.718 467.902C634.616 467.902 662.906 439.612 662.906 404.714C662.906 369.817 634.616 341.526 599.718 341.526C564.82 341.526 536.53 369.817 536.53 404.714C536.53 439.612 564.82 467.902 599.718 467.902Z",
    fill: "white",
    stroke: "#D70365",
    strokeWidth: 1.50769,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M635.609 440.608C655.437 420.78 655.437 388.632 635.609 368.804C615.781 348.976 583.633 348.976 563.805 368.804C543.977 388.632 543.977 420.78 563.805 440.608C583.633 460.436 615.781 460.436 635.609 440.608Z",
    fill: "white",
    stroke: "#D70365",
    strokeWidth: 1.49314,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M599.718 527.429C599.718 527.429 599.718 479.25 550.86 473.286C546.787 513.463 599.718 527.429 599.718 527.429Z",
    fill: "#D70365"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M561.189 486.67L588.152 513.003",
    stroke: "white",
    strokeWidth: 1.50769,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M599.936 527.987C599.936 527.987 599.936 479.808 648.794 473.843C652.868 514.02 599.936 527.987 599.936 527.987Z",
    fill: "#D70365"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M638.465 487.228L611.502 513.56",
    stroke: "white",
    strokeWidth: 1.50769,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M579.278 397.488V411.527C579.278 423.069 588.565 432.404 600.106 432.404C611.648 432.404 620.983 423.045 620.983 411.527V397.488H579.278ZM602.604 418.947H597.609V408.302H602.604V418.947Z",
    fill: "#D70365"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M613.127 393.463V390.748C613.127 383.571 607.308 377.727 600.106 377.727C592.929 377.727 587.085 383.546 587.085 390.748V393.463",
    stroke: "#D70365",
    strokeWidth: 4.84942,
    strokeMiterlimit: 10
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M643.193 330.979C643.193 330.979 685.189 255.231 610.169 213.017",
    stroke: "#D70365",
    strokeWidth: 1.50769,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "15.08 15.08"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M379.797 175.046L377.445 156.958L371.82 157.685L360.714 143.21L362.897 137.972L346.045 130.965L343.887 136.202L325.799 138.554L322.355 134.044L307.88 145.125L311.323 149.635L304.316 166.463L298.69 167.19L301.042 185.278L306.668 184.551L317.748 199.026L315.566 204.264L332.418 211.271L334.6 206.034L352.689 203.682L356.132 208.192L370.607 197.087L367.164 192.577L374.171 175.725L379.797 175.046ZM341.123 185.618C333.121 186.66 325.798 181.035 324.756 173.034C323.713 165.032 329.339 157.709 337.34 156.667C345.342 155.624 352.664 161.249 353.707 169.251C354.75 177.253 349.124 184.575 341.123 185.618Z",
    fill: "#D70365"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M355.816 1H102.749V73.3534H355.816V1Z",
    fill: "white",
    stroke: "#D70365",
    strokeWidth: 1.50769,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "15.08 15.08"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M140.696 48.3305C146.856 48.3305 151.85 43.3369 151.85 37.1768C151.85 31.0168 146.856 26.0232 140.696 26.0232C134.536 26.0232 129.542 31.0168 129.542 37.1768C129.542 43.3369 134.536 48.3305 140.696 48.3305Z",
    fill: "#FFE1EF"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M175.976 48.3305C182.136 48.3305 187.129 43.3369 187.129 37.1768C187.129 31.0168 182.136 26.0232 175.976 26.0232C169.816 26.0232 164.822 31.0168 164.822 37.1768C164.822 43.3369 169.816 48.3305 175.976 48.3305Z",
    fill: "#FFE1EF"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M211.231 48.3305C217.391 48.3305 222.385 43.3369 222.385 37.1768C222.385 31.0168 217.391 26.0232 211.231 26.0232C205.071 26.0232 200.077 31.0168 200.077 37.1768C200.077 43.3369 205.071 48.3305 211.231 48.3305Z",
    fill: "#FFE1EF"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M246.486 48.3305C252.646 48.3305 257.64 43.3369 257.64 37.1768C257.64 31.0168 252.646 26.0232 246.486 26.0232C240.326 26.0232 235.332 31.0168 235.332 37.1768C235.332 43.3369 240.326 48.3305 246.486 48.3305Z",
    fill: "#FFE1EF"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M281.742 48.3305C287.902 48.3305 292.895 43.3369 292.895 37.1768C292.895 31.0168 287.902 26.0232 281.742 26.0232C275.582 26.0232 270.588 31.0168 270.588 37.1768C270.588 43.3369 275.582 48.3305 281.742 48.3305Z",
    fill: "#FFE1EF"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M328.151 37.1768C328.151 43.3356 323.156 48.3305 316.997 48.3305C310.838 48.3305 305.843 43.3356 305.843 37.1768C305.843 31.0181 310.838 26.0232 316.997 26.0232C323.18 26.0232 328.151 31.0181 328.151 37.1768Z",
    fill: "#FFE1EF"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M574.695 163.092C569.167 168.62 560.22 168.62 554.691 163.092C549.163 157.563 549.163 148.616 554.691 143.088C560.22 137.56 569.167 137.56 574.695 143.088C580.224 148.616 580.224 157.563 574.695 163.092Z",
    fill: "#D70365"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M564.681 153.078L540.095 177.689L547.781 185.375",
    stroke: "#D70365",
    strokeWidth: 7.27414,
    strokeMiterlimit: 10
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M552.655 176.428L547.005 170.778",
    stroke: "#D70365",
    strokeWidth: 7.27414,
    strokeMiterlimit: 10
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M570.016 158.412C567.082 161.346 562.329 161.346 559.371 158.412C556.437 155.478 556.437 150.725 559.371 147.767C562.305 144.833 567.057 144.833 570.016 147.767C572.949 150.701 572.949 155.478 570.016 158.412Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdminLogin);
export default __webpack_public_path__ + "static/media/adminLogin.00430c6696b6f804f270c2c4712dc3d0.svg";
export { ForwardRef as ReactComponent };